import React, {
  useEffect,
  useRef,
  useCallback
} from 'react';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import { mount, unmount } from 'redom';

import application from 'application';

import Helpers from '../../../helpers';
import nodeControls from '../../../node-menu/control-types';

import BaseElement from '../../base';

import FormEditor from './';

import './index.scss';

function HTForm(props) {

  const element = props.element;

  const htFormContainerReference = useRef(null);
  const formEditorReference = useRef(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const formEditorChangeCallback = useCallback(handleFormEditorChange, []);
  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  useEffect(function onLoad() {

    application.dynamicModulesManager.load('ace');

    initialize();

    const htFormContainer = htFormContainerReference.current;

    return function onUnload() {

      if (formEditorReference.current === null) {
        return;
      }

      unmount(htFormContainer, formEditorReference.current);
      formEditorReference.current = null;

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onFormEditorChange() {

    initializeFormEditor();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formEditorReference.current, htFormContainerReference.current]);

  useEffect(function onElementChange() {

    if (formEditorReference.current === null) {
      return;
    }

    formEditorReference.current.update(buildFormEditorConfiguration());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element]);

  function initializeFormEditor() {

    if (formEditorReference.current !== null) {
      return;
    }

    if (htFormContainerReference.current === null) {
      return;
    }

    const configuration = buildFormEditorConfiguration();

    const formEditor = new FormEditor({
      ...configuration,
      onChange: formEditorChangeCallback
    });

    formEditorReference.current = formEditor;

    mount(htFormContainerReference.current, formEditor);

  }

  function buildFormEditorConfiguration() {

    const elementOptions = element.options;
    const properties = element.properties;

    const configuration = {
      pageId: props.parentEntityId,
      formId: elementOptions?.formId,
      page: props.parentEntity,
      properties
    };

    return configuration;

  }

  async function initialize() {

    initializeFormEditor();

  }

  function handleFormEditorChange(changes) {

    const element = Helpers.getNodeByPath(editor, elementPath);

    const properties = element.properties || {};
    const newProperties = {
      ...properties
    };

    Helpers.setAttributes(editor, {
      options: {
        ...changes,
        id: element.options?.id
      },
      properties: newProperties
    }, elementPath);

  }

  function renderHTForm() {

    const mainAttributes = {
      ...props.attributes,
      className: 'ht-form-element',
      contentEditable: false
    };

    const containerAttributes = {
      className: 'ht-form-element-container',
      ref: htFormContainerReference,
      contentEditable: false,
      style: {
        userselect: 'none'
      }
    };

    return <div {...mainAttributes}>
      <div {...containerAttributes}>
      </div>
      {props.children}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'ht-form-wrapper',
      customNodeControls: [
        nodeControls.ALIGNMENT
      ]
    };

    return <BaseElement {...baseElementProperties}>
      {renderHTForm()}
    </BaseElement>;

  }

  return renderMain();

}

export default HTForm;